const countries = [
    { name: 'Lietuva', value: 'LT' },
    { name: 'Andora', value: 'AD' },
    { name: 'Jungtiniai Arabų Emyratai', value: 'AE' },
    { name: 'Afganistanas', value: 'AF' },
    { name: 'Antigva ir Barbuda', value: 'AG' },
    { name: 'Angilija', value: 'AI' },
    { name: 'Albanija', value: 'AL' },
    { name: 'Armėnija', value: 'AM' },
    { name: 'Angola', value: 'AO' },
    { name: 'Antarktis', value: 'AQ' },
    { name: 'Argentina', value: 'AR' },
    { name: 'Amerikos Samoa', value: 'AS' },
    { name: 'Austrija', value: 'AT' },
    { name: 'Australija', value: 'AU' },
    { name: 'Aruba', value: 'AW' },
    { name: 'Alandai', value: 'AX' },
    { name: 'Azerbaidžanas', value: 'AZ' },
    { name: 'Bosnija ir Hercegovina', value: 'BA' },
    { name: 'Barbadosas', value: 'BB' },
    { name: 'Bangladešas', value: 'BD' },
    { name: 'Belgija', value: 'BE' },
    { name: 'Burkina Fasas', value: 'BF' },
    { name: 'Bulgarija', value: 'BG' },
    { name: 'Bahreinas', value: 'BH' },
    { name: 'Burundis', value: 'BI' },
    { name: 'Beninas', value: 'BJ' },
    { name: 'Sen Bartelemi', value: 'BL' },
    { name: 'Bermuda', value: 'BM' },
    { name: 'Brunėjus', value: 'BN' },
    { name: 'Bolivija', value: 'BO' },
    { name: 'Brazilija', value: 'BR' },
    { name: 'Bahamos', value: 'BS' },
    { name: 'Butanas', value: 'BT' },
    { name: 'Buvė', value: 'BV' },
    { name: 'Botsvana', value: 'BW' },
    { name: 'Baltarusija', value: 'BY' },
    { name: 'Belizas', value: 'BZ' },
    { name: 'Kanada', value: 'CA' },
    { name: 'Kokosų (Kilingo) Salos', value: 'CC' },
    { name: 'Kongo Demokratinė Respublika', value: 'CD' },
    { name: 'Centrinės Afrikos Respublika', value: 'CF' },
    { name: 'Kongas', value: 'CG' },
    { name: 'Šveicarija', value: 'CH' },
    { name: 'Dramblio Kaulo Krantas', value: 'CI' },
    { name: 'Kuko Salos', value: 'CK' },
    { name: 'Čilė', value: 'CL' },
    { name: 'Kamerūnas', value: 'CM' },
    { name: 'Kinija', value: 'CN' },
    { name: 'Kolumbija', value: 'CO' },
    { name: 'Klipertonas', value: 'CP' },
    { name: 'Kosta Rika', value: 'CR' },
    { name: 'Kuba', value: 'CU' },
    { name: 'Žaliasis Kyšulys', value: 'CV' },
    { name: 'Kiurasao', value: 'CW' },
    { name: 'Kalėdų Sala', value: 'CX' },
    { name: 'Kipras', value: 'CY' },
    { name: 'Čekija', value: 'CZ' },
    { name: 'Vokietija', value: 'DE' },
    { name: 'Džibutis', value: 'DJ' },
    { name: 'Danija', value: 'DK' },
    { name: 'Dominika', value: 'DM' },
    { name: 'Dominikos Respublika', value: 'DO' },
    { name: 'Alžyras', value: 'DZ' },
    { name: 'Ekvadoras', value: 'EC' },
    { name: 'Estija', value: 'EE' },
    { name: 'Egiptas', value: 'EG' },
    { name: 'Vakarų Sachara', value: 'EH' },
    { name: 'Graikija', value: 'EL' },
    { name: 'Eritrėja', value: 'ER' },
    { name: 'Ispanija', value: 'ES' },
    { name: 'Etiopija', value: 'ET' },
    { name: 'Suomija', value: 'FI' },
    { name: 'Fidžis', value: 'FJ' },
    { name: 'Folklandas', value: 'FK' },
    { name: 'Mikronezija', value: 'FM' },
    { name: 'Farerai', value: 'FO' },
    { name: 'Prancūzija', value: 'FR' },
    { name: 'Gabonas', value: 'GA' },
    { name: 'Grenada', value: 'GD' },
    { name: 'Sakartvelas', value: 'GE' },
    { name: 'Prancūzijos Gviana', value: 'GF' },
    { name: 'Gernsis', value: 'GG' },
    { name: 'Gana', value: 'GH' },
    { name: 'Gibraltaras', value: 'GI' },
    { name: 'Grenlandija', value: 'GL' },
    { name: 'Gambija', value: 'GM' },
    { name: 'Gvinėja', value: 'GN' },
    { name: 'Gvadelupa', value: 'GP' },
    { name: 'Pusiaujo Gvinėja', value: 'GQ' },
    { name: 'Pietų Džordžija ir Pietų Sandvičas', value: 'GS' },
    { name: 'Gvatemala', value: 'GT' },
    { name: 'Guamas', value: 'GU' },
    { name: 'Bisau Gvinėja', value: 'GW' },
    { name: 'Gajana', value: 'GY' },
    { name: 'Honkongas', value: 'HK' },
    { name: 'Herdas ir Makdonaldas', value: 'HM' },
    { name: 'Hondūras', value: 'HN' },
    { name: 'Kroatija', value: 'HR' },
    { name: 'Haitis', value: 'HT' },
    { name: 'Vengrija', value: 'HU' },
    { name: 'Indonezija', value: 'ID' },
    { name: 'Airija', value: 'IE' },
    { name: 'Izraelis', value: 'IL' },
    { name: 'Menas', value: 'IM' },
    { name: 'Indija', value: 'IN' },
    { name: 'Indijos Vandenyno Britų Sritis', value: 'IO' },
    { name: 'Irakas', value: 'IQ' },
    { name: 'Iranas', value: 'IR' },
    { name: 'Islandija', value: 'IS' },
    { name: 'Italija', value: 'IT' },
    { name: 'Džersis', value: 'JE' },
    { name: 'Jamaika', value: 'JM' },
    { name: 'Jordanija', value: 'JO' },
    { name: 'Japonija', value: 'JP' },
    { name: 'Kenija', value: 'KE' },
    { name: 'Kirgizija', value: 'KG' },
    { name: 'Kambodža', value: 'KH' },
    { name: 'Kiribatis', value: 'KI' },
    { name: 'Komorai', value: 'KM' },
    { name: 'Sent Kitsas ir Nevis', value: 'KN' },
    { name: 'Šiaurės Korėja', value: 'KP' },
    { name: 'Pietų Korėja', value: 'KR' },
    { name: 'Kuveitas', value: 'KW' },
    { name: 'Kaimanai', value: 'KY' },
    { name: 'Kazachstanas', value: 'KZ' },
    { name: 'Laosas', value: 'LA' },
    { name: 'Libanas', value: 'LB' },
    { name: 'Sent Lusija', value: 'LC' },
    { name: 'Lichtenšteinas', value: 'LI' },
    { name: 'Šri Lanka', value: 'LK' },
    { name: 'Liberija', value: 'LR' },
    { name: 'Lesotas', value: 'LS' },
    { name: 'Liuksemburgas', value: 'LU' },
    { name: 'Latvija', value: 'LV' },
    { name: 'Libija', value: 'LY' },
    { name: 'Marokas', value: 'MA' },
    { name: 'Monakas', value: 'MC' },
    { name: 'Moldova', value: 'MD' },
    { name: 'Juodkalnija', value: 'ME' },
    { name: 'Sen Martenas', value: 'MF' },
    { name: 'Madagaskaras', value: 'MG' },
    { name: 'Maršalo Salos', value: 'MH' },
    { name: 'Šiaurės Makedonija', value: 'MK' },
    { name: 'Malis', value: 'ML' },
    { name: 'Mongolija', value: 'MN' },
    { name: 'Makao', value: 'MO' },
    { name: 'Marianos Šiaurinės Salos', value: 'MP' },
    { name: 'Martinika', value: 'MQ' },
    { name: 'Mauritanija', value: 'MR' },
    { name: 'Montseratas', value: 'MS' },
    { name: 'Malta', value: 'MT' },
    { name: 'Mauricijus', value: 'MU' },
    { name: 'Maldyvai', value: 'MV' },
    { name: 'Malavis', value: 'MW' },
    { name: 'Meksika', value: 'MX' },
    { name: 'Malaizija', value: 'MY' },
    { name: 'Mozambikas', value: 'MZ' },
    { name: 'Namibija', value: 'NA' },
    { name: 'Naujoji Kaledonija', value: 'NC' },
    { name: 'Nigeris', value: 'NE' },
    { name: 'Norfolko Sala', value: 'NF' },
    { name: 'Nigerija', value: 'NG' },
    { name: 'Nikaragva', value: 'NI' },
    { name: 'Nyderlandai', value: 'NL' },
    { name: 'Norvegija', value: 'NO' },
    { name: 'Nepalas', value: 'NP' },
    { name: 'Nauru', value: 'NR' },
    { name: 'Niujė', value: 'NU' },
    { name: 'Naujoji Zelandija', value: 'NZ' },
    { name: 'Omanas', value: 'OM' },
    { name: 'Panama', value: 'PA' },
    { name: 'Peru', value: 'PE' },
    { name: 'Prancūzijos Polinezija', value: 'PF' },
    { name: 'Papua Naujoji Gvinėja', value: 'PG' },
    { name: 'Filipinai', value: 'PH' },
    { name: 'Pakistanas', value: 'PK' },
    { name: 'Lenkija', value: 'PL' },
    { name: 'Sen Pjeras ir Mikelonas', value: 'PM' },
    { name: 'Mianmaras / Birma', value: 'MM' },
    { name: 'Pitkernas', value: 'PN' },
    { name: 'Puerto Rikas', value: 'PR' },
    { name: 'Portugalija', value: 'PT' },
    { name: 'Palau', value: 'PW' },
    { name: 'Paragvajus', value: 'PY' },
    { name: 'Kataras', value: 'QA' },
    { name: 'Reunjonas', value: 'RE' },
    { name: 'Rumunija', value: 'RO' },
    { name: 'Serbija', value: 'RS' },
    { name: 'Rusija', value: 'RU' },
    { name: 'Ruanda', value: 'RW' },
    { name: 'Saudo Arabija', value: 'SA' },
    { name: 'Saliamono Salos', value: 'SB' },
    { name: 'Seišeliai', value: 'SC' },
    { name: 'Sudanas', value: 'SD' },
    { name: 'Švedija', value: 'SE' },
    { name: 'Singapūras', value: 'SG' },
    { name: 'Šv. Elenos, Dangun Žengimo ir Tristano da Kunjos Salos', value: 'SH' },
    { name: 'Slovėnija', value: 'SI' },
    { name: 'Svalbardas ir Janas Majenas', value: 'SJ' },
    { name: 'Slovakija', value: 'SK' },
    { name: 'Siera Leonė', value: 'SL' },
    { name: 'San Marinas', value: 'SM' },
    { name: 'Senegalas', value: 'SN' },
    { name: 'Somalis', value: 'SO' },
    { name: 'Surinamas', value: 'SR' },
    { name: 'Pietų Sudanas', value: 'SS' },
    { name: 'Salvadoras', value: 'SV' },
    { name: 'Sint Martenas', value: 'SX' },
    { name: 'Sirija', value: 'SY' },
    { name: 'Esvatinis', value: 'SZ' },
    { name: 'Terksas ir Kaikosas', value: 'TC' },
    { name: 'Čadas', value: 'TD' },
    { name: 'Prancūzijos Pietų ir Antarkties Sritys', value: 'TF' },
    { name: 'Togas', value: 'TG' },
    { name: 'Tailandas', value: 'TH' },
    { name: 'Tadžikistanas', value: 'TJ' },
    { name: 'Tokelau', value: 'TK' },
    { name: 'Rytų Timoras', value: 'TL' },
    { name: 'Turkmėnistanas', value: 'TM' },
    { name: 'Tunisas', value: 'TN' },
    { name: 'Tonga', value: 'TO' },
    { name: 'Turkija', value: 'TR' },
    { name: 'Trinidadas ir Tobagas', value: 'TT' },
    { name: 'San Tomė ir Prinsipė ', value: 'ST' },
    { name: 'Tuvalu', value: 'TV' },
    { name: 'Taivanas', value: 'TW' },
    { name: 'Tanzanija', value: 'TZ' },
    { name: 'Ukraina', value: 'UA' },
    { name: 'Uganda', value: 'UG' },
    { name: 'Jungtinė Karalystė (Didžioji Britanija)', value: 'UK' },
    { name: 'Mažosios Tolimosios Salos', value: 'UM' },
    { name: 'Jungtinės Amerikos Valstijos', value: 'US' },
    { name: 'Urugvajus', value: 'UY' },
    { name: 'Uzbekistanas', value: 'UZ' },
    { name: 'Sent Vinsentas ir Grenadinai', value: 'VC' },
    { name: 'Venesuela', value: 'VE' },
    { name: 'Mergelių Salos (Didžioji Britanija)', value: 'VG' },
    { name: 'Mergelių Salos (JAV)', value: 'VI' },
    { name: 'Vietnamas', value: 'VN' },
    { name: 'Vanuatu', value: 'VU' },
    { name: 'Volisas ir Futūna', value: 'WF' },
    { name: 'Samoa', value: 'WS' },
    { name: 'Jemenas', value: 'YE' },
    { name: 'Majotas', value: 'YT' },
    { name: 'Pietų Afrika', value: 'ZA' },
    { name: 'Zambija', value: 'ZM' },
    { name: 'Zimbabvė', value: 'ZW' }
]

const eu = [
    'AT',
    'BE',
    'BG',
    'HR',
    'CY',
    'CZ',
    'DK',
    'EE',
    'FI',
    'FR',
    'DE',
    'GR',
    'HU',
    'IE',
    'IT',
    'LV',
    //'LT',
    'LU',
    'MT',
    'NL',
    'PL',
    'PT',
    'RO',
    'SK',
    'SI',
    'ES',
    'SE'
]

const global = [
    'US',
    'GB',
    'CA',
    'AU',
    'MK',
    'MY',
    'MC',
    'ME',
    'NZ',
    'NF',
    'NO',
    'PH',
    'RS',
    'SG',
    'CH',
    'TW',
    'GK',
    'BA',
    'GE',
    'LI',
    'HK',
    'IS',
    'IN',
    'ID',
    'IL',
    'JP',
    'UK',
    'JO'
]

export { countries as default, eu, global }
